import { gql } from '@apollo/client';
import { CRM_TASK_FIELDS } from './queries';

export const CREATE_CRM_TASK = gql`
    mutation CreateCrmTask($input: CreateCrmTaskInput!) {
        createCrmTask(input: $input) {
            ${CRM_TASK_FIELDS}
        }
    }
`;

export const UPDATE_CRM_TASK = gql`
    mutation UpdateCrmTask($input: UpdateCrmTaskInput!) {
        updateCrmTask(input: $input) {
            ${CRM_TASK_FIELDS}
        }
    }
`;

export const COMPLETE_CRM_TASK = gql`
    mutation CompleteCrmTask($taskId: String!) {
        completeCrmTask(taskId: $taskId) {
            ${CRM_TASK_FIELDS}
        }
    }
`;

export const DELETE_CRM_TASK = gql`
    mutation DeleteCrmTask($taskId: String!, $scope: DeleteTaskOptionEnum) {
        deleteCrmTask(taskId: $taskId, scope: $scope) {
            ${CRM_TASK_FIELDS}
        }
    }
`;
